import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {
	currentUserHasAccess,
	PermissionName,
} from '@netx/core-permissions-next/enablers';

export const canUploadAttributes = (): boolean => {
	if (!currentUserMeetsUserLevel(UserLevel.PRODUCER)) return false;
	return currentUserHasAccess(PermissionName.UPLOAD_ATTRIBUTE_DATA);
};
